export enum EducationType {
    NO_COLLEGE = 'no college degree',
    SOME_COLLEGE = 'some college',
    BACHELORS = 'bachelors degree',
    MASTERS = 'masters degree',
}
